import { useWhatsappConfiguration } from "V2.0/HomePages/Integrations/Whatsapp/models/useWhatsappConfiguration";
import useMcubeEngageConfiguration from "V2.0/HomePages/Integrations/Communications/Whatsapp/MCubeEngage/useMCubeEngageConfiguration";

import MetaWhatsApp from "./Meta";
import MCubeEngageWhatsapp from "./MCubeEngage";

export function WhatsApp(props) {
  const { fromNumber, projectId } = props;

  const { whatsappConfiguration, fetchWhatsappConfiguration } =
    useWhatsappConfiguration(projectId);

  const { mcubeEngageConfiguration, isConfigured: isMCubeEngageConfigured } =
    useMcubeEngageConfiguration(projectId);

  function isNumberFromWhatsappConfiguration() {
    const { phoneNumberIds } = whatsappConfiguration.data;

    if (phoneNumberIds.includes(fromNumber)) {
      return true;
    }

    return false;
  }

  function isNumberFromMCubeEngageConfiguration() {
    const phoneNumbers = mcubeEngageConfiguration.phoneNumbers;

    if (phoneNumbers.includes(fromNumber)) return true;

    return false;
  }

  if (isMCubeEngageConfigured && isNumberFromMCubeEngageConfiguration()) {
    return <MCubeEngageWhatsapp {...props} />;
  }

  return <MetaWhatsApp {...props} />;
}
